import { z } from 'zod';
// Email notification action types
export const NotificationActionSchema = z.enum(['UPDATE', 'DELETE']);
// Email Notification Schema
export const EmailNotificationSchema = z.object({
    action: NotificationActionSchema,
    customerKey: z.string(),
    changedFields: z.array(z.string()).optional(),
    oldValues: z.record(z.any()).optional(),
    newValues: z.record(z.any()).optional(),
    userEmail: z.string().email(),
    timestamp: z.string().datetime(),
    toEmail: z.string().email(),
    fromEmail: z.string().email(),
});
//# sourceMappingURL=notification.schema.js.map